const { create_sdk, apiURL } = require('ks_data_protocol_ui');
global.app = { create_sdk: create_sdk, sdk: {} };
global.app['apiURL'] = apiURL;
global.app['version'] = { isLatest: true, worker: null, serviceWorkerRegistration: null, number: process.env.APP_VERSION };
global.app['installPrompt'] = null;

const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const getSubdomain = () => {
  const host = window.location.hostname;
  console.log(host);
  const subdomain = host.split('.')[0];
  if (!subdomain) return 'ERPeach';
  if (subdomain == 'test') return 'ERPeach';
  if (subdomain == 'erpeach') return 'ERPeach';
  return subdomain;
};

const appTitle = getSubdomain();
if (appTitle != 'ERPeach') {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `${apiURL}/file/campaign/css/${appTitle}`;
  link.type = 'text/css';
  document.head.appendChild(link);
  global.app['title'] = capitalizeFirstLetter(appTitle);
} else {
  global.app['title'] = appTitle;
}

console.log(global.app['title']);

window.addEventListener('appinstalled', () => {
  global.app['installPrompt'] = null;
});

window.addEventListener('beforeinstallprompt', async event => {
  event.preventDefault();
  const relatedApps = await navigator.getInstalledRelatedApps();
  console.log('appsInstalled ==>', relatedApps);
  const psApp = relatedApps.find(app => app.id === 'ERPeach');
  if (psApp) {
    global.app['installPrompt'] = null;
  } else {
    global.app['installPrompt'] = event;
  }
});

export default {};
